import http from "../http-common";

class ConfigPerfilReaderService {
  listPerfilReader(idEntitat) {
    return http.get("/config-perfil-reader/list/"+idEntitat);
  }
}

export default new ConfigPerfilReaderService();